import { createSlice, createAction } from "@reduxjs/toolkit";

export const initialState = {
  accessToken: null,
  refreshToken: null,
  expirationTimestamp: null,
  tokenExpiryMs: null,
  userId: null,
  customerId: null,
  roles: [],
  email: "",
};

export const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAccessTokenData: (state, action) => {
      Object.assign(state, action.payload);
      state.error = null;
    },
    clearAccessTokenData: (state) => {
      const { email, ...clearState } = initialState;
      Object.assign(state, clearState);
    },
    setEmail: (state, action) => {
      state.email = action.payload || "";
    },
  },
});

export const {
  setAccessTokenData,
  clearAccessTokenData,
  setEmail,
} = slice.actions;

export const login = createAction("login");
export const logout = createAction("logout");
export const autoLogin = createAction("autoLogin");
export const loginSuccess = createAction("loginSuccess");
export const loginFailure = createAction("loginFailure");

export const selectEmail = (state) => state.auth.email;

export const selectAccessToken = (state) => {
  const { accessToken, expirationTimestamp } = state.auth;
  return accessToken && expirationTimestamp > Date.now() ? accessToken : null;
};
export const selectIsAuthorized = (state) => !!selectAccessToken(state);
export const selectRemainingTokenTimeMs = (state) => {
  return state.auth.expirationTimestamp - Date.now();
};
export const selectCurrentUserId = (state) => state.auth.userId;
export const selectCurrentCustomerId = (state) => state.auth.customerId;
export const selectCurrentUserRoles = (state) => state.auth.roles;

export const selectRefreshToken = (state) => state.auth.refreshToken;

export default slice.reducer;
